/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipologiaPratica } from './tipologia-pratica';


export interface TipoPraticaCittadinoListFilter { 
    tipologia?: TipologiaPratica;
    solo_aperti?: boolean;
    q?: string;
}



